import { useArticlesSearchProvider } from './useArticleSearchProvider'

export const useChangeSearchParams = (): ((params) => void) => {
  const { changeSearchParams } = useArticlesSearchProvider()
  return changeSearchParams
}
